import { motion } from "framer-motion";
import { scrollToId } from "@/App";

const FABRICS = [
  { name: "Pure & Blended Silks", note: "Charmeuse, habotai & silk satin" },
  { name: "Chiffon & Georgette", note: "Fluid drapes for abayas & dresses" },
  { name: "Cotton & Lawn", note: "Combed, printed & embroidered" },
  { name: "Occasion & Embroidered", note: "Zari, sequin & bridal collections" },
];

export default function Fabrics() {
  return (
    <section id="fabrics" data-testid="womens-fabric-section" className="py-20 lg:py-32 px-4 sm:px-8 lg:px-16 bg-[#0A0B0E]">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-5 relative"
        >
          <div className="border border-[#D4AF37]/30 p-3">
            <div className="overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1520006403909-838d6b92c22e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000"
                alt="Rolls of women's fabrics in silk and cotton"
                className="w-full h-[520px] object-cover hover:scale-[1.04] transition-transform duration-700"
              />
            </div>
          </div>
          <div className="absolute -bottom-6 -right-4 sm:-right-6 bg-[#181B24] border border-[#D4AF37]/30 px-6 py-4">
            <p className="text-[10px] font-mono tracking-[0.3em] uppercase text-[#D4AF37]/80">Bulk Tier Matrix</p>
            <p className="font-display text-2xl text-amber-100 mt-1">From 100 m / design</p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-7"
        >
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-[#D4AF37]/80 mb-4">Women's Fabric Wholesale — Our Core Trade</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-snug">
            Silks, chiffons & georgettes — <span className="italic text-gold-gradient">fabric is where we began.</span>
          </h2>
          <p className="mt-6 text-base sm:text-lg font-light leading-relaxed text-slate-300 max-w-xl">
            Women's fabric is the heart of ATS. We carry season-fresh silks, flowing chiffons, breathable cottons and
            embroidered occasion materials — inspected lot by lot, with shades matched across repeat orders and
            custom dyeing on request.
          </p>
          <ul className="mt-10 divide-y divide-[#D4AF37]/15 border-y border-[#D4AF37]/15">
            {FABRICS.map((it, i) => (
              <li key={it.name} className="py-5 flex items-baseline justify-between gap-6" data-testid={`fabric-item-${i + 1}`}>
                <span className="font-display text-xl sm:text-2xl text-amber-100">{it.name}</span>
                <span className="text-sm font-light text-slate-400 text-right">{it.note}</span>
              </li>
            ))}
          </ul>
          <button
            data-testid="fabric-rfq-button"
            onClick={() => scrollToId("#contact")}
            className="mt-10 px-8 py-4 border border-[#D4AF37]/70 text-[#D4AF37] text-xs tracking-[0.22em] uppercase hover:bg-[#D4AF37] hover:text-[#0A0B0E] transition-colors duration-300"
          >
            Get Fabric Bulk Pricing
          </button>
        </motion.div>
      </div>
    </section>
  );
}
